export { default } from './submission-success';
